import React, { Component, Fragment } from 'react';
import { Row, Col, Navbar, Nav, Button, Form, Modal } from 'react-bootstrap';
import { LineChart, Line, Tooltip, XAxis } from 'recharts';
import { TableKPI } from './KPITables';

function getdate(dateBack){
    var d = new Date();
    d = d.setDate(d.getDate() - dateBack);
    var n = new Date(d).toLocaleDateString();
    return n;
}

export class SimpleLineChart extends Component {
    constructor(props){
        super(props);

        this.state = {
            daysago7 : 0,
            daysago6 : 0,
            daysago5 : 0,
            daysago4 : 0,
            daysago3 : 0,
            daysago2 : 0,
            daysago1 : 0,
        };

    }

    componentDidMount(){
        var data = this.props.days[0];
        this.setState({
            daysago7 : data.daysago7,
            daysago6 : data.daysago6,
            daysago5 : data.daysago5,
            daysago4 : data.daysago4,
            daysago3 : data.daysago3,
            daysago2 : data.daysago2,
            daysago1 : data.daysago1,
        });
    }

    componentDidUpdate(prevProps){
        if(prevProps.days !== this.props.days){
            var data = this.props.days[0];
            this.setState({
                daysago7 : data.daysago7,
                daysago6 : data.daysago6,
                daysago5 : data.daysago5,
                daysago4 : data.daysago4,
                daysago3 : data.daysago3,
                daysago2 : data.daysago2,
                daysago1 : data.daysago1,
            });
        }        
    }

    render () {       
        const data = [
            {name: getdate(7) , searches: this.state.daysago7 },
            {name: getdate(6), searches: this.state.daysago6 },
            {name: getdate(5), searches: this.state.daysago5 },
            {name: getdate(4), searches: this.state.daysago4 },
            {name: getdate(3), searches: this.state.daysago3 },
            {name: getdate(2), searches: this.state.daysago2 },
            {name: getdate(1), searches: this.state.daysago1 },
        ];

        return (
            <LineChart width={500} height={200} data={data}
            margin={{top: 20, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="name" hidden/>
            <Tooltip />
            <Line type="monotone" dataKey="searches" stroke="#8884d8" activeDot={{r: 8}}/>
            </LineChart>
        );
    }
}

export default class SearchMetrics extends Component {
    constructor(props){
        super(props);

        this.state = {
            Today: this.props.metric.Today,
            SevenDaysBack: this.props.metric.SevenDaysBack,
            ThirtyDaysBack: this.props.metric.ThirtyDaysBack,
            YearBack: this.props.metric.YearBack,
            CurrentWeek: this.props.metric.CurrentWeek,
            PreviousWeek: this.props.metric.PreviousWeek,
            CurrentMonth: this.props.metric.CurrentMonth,
            PreviousMonth: this.props.metric.PreviousMonth,
            daysAgo: this.props.metric.daysAgo,
            Basic: this.props.metric.Basic,
            Filtered: this.props.metric.Filtered,
            AvgPage: this.props.metric.AvgPage,
            AvgResult: this.props.metric.AvgResult,
            AvgResponseTime: this.props.metric.AvgResponseTime,
            smartPanelDisplayed: this.props.metric.smartPanelDisplayed ,
            smartPanelInteracted: this.props.metric.smartPanelInteracted,
        };
    }

    componentDidUpdate(prevProps){
        if(prevProps.metric !== this.props.metric){
            this.setState({
                Today: this.props.metric.Today,
                SevenDaysBack: this.props.metric.SevenDaysBack,
                ThirtyDaysBack: this.props.metric.ThirtyDaysBack,
                YearBack: this.props.metric.YearBack,
                CurrentWeek: this.props.metric.CurrentWeek,
                PreviousWeek: this.props.metric.PreviousWeek,
                CurrentMonth: this.props.metric.CurrentMonth,
                PreviousMonth: this.props.metric.PreviousMonth,
                daysAgo: this.props.metric.daysAgo,
                Basic: this.props.metric.Basic,
                Filtered: this.props.metric.Filtered,
                AvgPage: this.props.metric.AvgPage,
                AvgResult: this.props.metric.AvgResult,
                AvgResponseTime: this.props.metric.AvgResponseTime,
                smartPanelDisplayed: this.props.metric.smartPanelDisplayed ,
                smartPanelInteracted: this.props.metric.smartPanelInteracted,
            });
        }
    }

    render(){
        return (
            <div>
                <p className="mt-4 header">Number of Searches</p>               
                <Row className="SearchMetric">                                              
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" onClick={() => this.setState({ showTable : true, DateFilter : "Today" })}>
                            <div className="bg"></div>
                            <p className="mb-0">Today</p> 
                            <h1>{this.state.Today}</h1>
                        </div>
                    </Col>
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" onClick={() => this.setState({ showTable : true, DateFilter : "Week" })}>
                            <div className="bg"></div>
                            <p className="mb-0">Last 7 Days</p> 
                            <h1>{this.state.SevenDaysBack}</h1>
                        </div>
                    </Col>
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" onClick={() => this.setState({ showTable : true, DateFilter : "Month" })}>
                            <div className="bg"></div>
                            <p className="mb-0">Last 30 Days</p> 
                            <h1>{this.state.ThirtyDaysBack}</h1>
                        </div>
                    </Col>
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" onClick={() => this.setState({ showTable : true, DateFilter : "Year" })}>
                            <div className="bg"></div>
                            <p className="mb-0">Year</p> 
                            <h1>{this.state.YearBack}</h1>
                        </div>
                    </Col>
                </Row> 
                <Row className="SearchMetric">                                              
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" style={{cursor : "default", color: "#a5a5a5"}}>    
                            <p className="mb-0">Current Week</p> 
                            <h1>{this.state.CurrentWeek}</h1>
                        </div>
                    </Col>
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" style={{cursor : "default", color: "#a5a5a5"}}>    
                            <p className="mb-0">Previous Week</p> 
                            <h1>{this.state.PreviousWeek}</h1>
                        </div>
                    </Col>
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" style={{cursor : "default", color: "#a5a5a5"}}>    
                            <p className="mb-0">Current Month</p> 
                            <h1>{this.state.CurrentMonth}</h1>
                        </div>
                    </Col>
                    <Col lg={{span : 3 }}>
                        <div className="kpi-box" style={{cursor : "default", color: "#a5a5a5"}}>
                            <p className="mb-0">Previous Month</p> 
                            <h1>{this.state.PreviousMonth}</h1>
                        </div>
                    </Col>
                </Row> 
                <p className="mt-4 header">Searches per Day (Last 7 Days)</p>
                <Row className="searchByDayChart">
                    <Col lg={{span: 12}}>
                        {this.state.daysAgo && (
                            <SimpleLineChart days={this.state.daysAgo} />
                        )}                            
                    </Col>
                </Row>
                <p className="mt-4 header">Search Type (All Time)</p>
                <Row>
                    <Col lg={{span: 6}}>
                        <div className="kpi-box">
                            <p className="mb-0">Basic</p> 
                            <h1>{this.state.Basic}</h1>
                        </div>
                    </Col>
                    <Col lg={{span: 6}}>
                        <div className="kpi-box">
                            <p className="mb-0">Filtered</p> 
                            <h1>{this.state.Filtered}</h1>
                        </div>
                    </Col>
                </Row>
                <Row style={{ margin: "25px 0"}}>
                    <Col lg={{span: 6}} className="pl-0">
                        <p className="mt-4 header">Average Click Through Result Number</p>                            
                        <div className="kpi-box">
                            <div className="double-option">
                                <span>Page</span>
                                <h1>{this.state.AvgPage}</h1>
                            </div>
                            <div className="double-option">
                                <span>Result</span>
                                <h1>{this.state.AvgResult}</h1>
                            </div>                                
                        </div>
                    </Col>
                    <Col lg={{span: 6}}>
                        <p className="mt-4 header">Most Clicked Target</p>
                        <div className="kpi-box" style={{ padding: "30px" }}>
                            <h1>D365</h1>
                        </div>
                    </Col>
                </Row>

                <Row style={{ margin: "25px 0"}}>
                    <Col lg={{span: 6}} className="pl-0">
                        <p className="mt-4 header">Average Response Time (All Time)</p>                            
                        <div className="kpi-box">
                            <div  style={{ padding: "30px" }}>
                                <h1>{this.state.AvgResponseTime && this.state.AvgResponseTime.toFixed(2)}s</h1>
                            </div>
                            
                        </div>
                    </Col>
                    <Col lg={{span: 6}}>
                        <p className="mt-4 header">Smart Panel</p>
                        <div className="kpi-box">
                            <div className="double-option">
                                <span>Displayed </span>
                                <h1>{this.state.smartPanelDisplayed}</h1>
                            </div>
                            <div className="double-option">
                                <span>Interacted </span>
                                <h1>{this.state.smartPanelInteracted}</h1>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className={this.state.showTable ? "table-container active" : "table-container"}>
                    <Col lg={{ span : 10, offset : 1 }}>
                        <Button variant="link" className="pl-0" onClick={() => this.setState({ showTable : false})}><small>&#60; Back to Analytics</small></Button>
                        <p><small>Times in UTC - want them in local time? request them <a href="mailto:supportcops@ceridian.com">here</a></small></p>
                        
                        <TableKPI KPIDateFilter={this.state.DateFilter} />
                    </Col>                    
                </div>
            </div> 
        );
    }
}

